import { Box, Grid, useEventCallback } from '@mui/material';
import { Fragment, memo, useMemo, useState } from 'react';
import { useFormikContext } from 'formik';
import {
  NewResidenceVM,
  PracticeEditResidence,
  TableDomesticPartnershipVM,
  TableFamiliarVM,
  TableNewFamilySubjectsVM,
} from 'practice/view-models/practice-edit-residence';
import ModalFamily from '../modal-family';
import ModalDomesticPartnership from '../modal-domestic-partnership';
import AccordionActualResidence from './accordion-actual-residence';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import { ResidenceID } from 'practice/constants/id-practice-edit-residence';
import ModalNewResidence from '../modal-new-residence';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { TypeRegister } from 'practice/constants/type-register';
import { FormActualResidenceVM } from 'practice/view-models/pratice-actual-residence';
import PracticeTemporaryActualResidence from './pratice-temporary-actual-residence-accordian';
import { TypeInitiative } from 'practice/constants/practice-management-step';
import { CODE_STATE_ITALIAN } from 'shell/constants/code-state-italian';

interface FormProps {
  idFamilyAnpr?: string;
  codeEnte?: string;
  yearId?: string;
  typeRegister?: string;
  intestatarioIsAnpr?: boolean;
  progressive?: string;
  typePractice?: string;
  ForPracticeTemporary?: boolean;
  disabled?: boolean;
  iniziativa?: string;
  fromPerson?: string;
}

const FormComponent = ({
  idFamilyAnpr,
  codeEnte,
  yearId,
  typeRegister,
  intestatarioIsAnpr,
  progressive,
  ForPracticeTemporary,
  typePractice,
  disabled,
  iniziativa,
  fromPerson,
}: FormProps): React.ReactElement => {
  const [modalFamily, setModalFamily] = useState({ open: false, isEdit: false });

  const [modalDomesticPartnership, setModalDomesticPartnership] = useState({
    open: false,
    isEdit: false,
  });

  const [modalNewResidence, setModalNewResidence] = useState({ open: false, isEdit: false });

  const formContext = useFormikContext<PracticeEditResidence>();

  const disabledButtons: boolean = useMemo(() => {
    const res = !ForPracticeTemporary
      ? !formContext.values?.effectiveDate ||
        formContext.values?.effectiveDate?.toString() === 'Invalid DateTime'
      : false;

    if (res) {
      // reset
      formContext.setValues({
        ...(formContext.values || {}),
        typeResidence: undefined,
        filter: undefined,
        tableFamiliar: undefined,
        tableNewFamilySubjects: undefined,
        filterDomesticPartnership: undefined,
        tableDomesticPartnership: undefined,
      });
    }

    return res;
  }, [formContext.values?.effectiveDate, ForPracticeTemporary]);

  const onChangeTypeResidence = useEventCallback((value: string) => {
    // reset
    formContext.setValues({
      ...(formContext.values || {}),
      typeResidence: value,
      filter: undefined,
      tableFamiliar: undefined,
      tableNewFamilySubjects: undefined,
      filterDomesticPartnership: undefined,
      tableDomesticPartnership: undefined,
      newResidence: undefined,
      residence: undefined,
    });

    // formContext.setFieldValue('typeResidence', value);
  });

  const onConfirmNewResidence = useEventCallback((valueNew: NewResidenceVM) => {
    formContext.setFieldValue('residence', {
      checkedResidence: valueNew?.checkedResidence || false,
      italian:
        valueNew?.italian && !valueNew?.checkedResidence
          ? {
              ...valueNew?.italian,
              address: valueNew.italian.addressAuto || valueNew.italian.address || null,
            }
          : undefined,
      foreign: valueNew?.checkedResidence && valueNew?.foreign ? valueNew?.foreign : undefined,
      flagAttualeResidenza: valueNew.flagAttualeResidenza || false,
    });

    setModalNewResidence({ open: false, isEdit: modalNewResidence.isEdit });
  });

  const onEdit = useEventCallback(() => {
    switch (formContext.values.typeResidence) {
      case ResidenceID.allFamily:
      case ResidenceID.new:
        setModalNewResidence({ open: true, isEdit: true });
        return;
      case ResidenceID.family:
        setModalFamily({ open: true, isEdit: true });
        return;
      case ResidenceID.domesticPartnership:
        setModalDomesticPartnership({ open: true, isEdit: true });
        return;
      default:
        return;
    }
  });

  // const controlButtonNew = useMemo(() => {
  //   // se lo stato è allFamily e ci sono dati salvati disabilitare

  //   if (formContext.values.typeResidence !== ResidenceID.allFamily) {
  //     return false;
  //   }

  //   if (
  //     !formContext.values.residence?.checkedResidence &&
  //     formContext.values.residence?.italian?.municipality?.description
  //   ) {
  //     // presente italia
  //     return true;
  //   }

  //   if (
  //     formContext.values.residence?.checkedResidence &&
  //     formContext.values.residence?.foreign?.foreignState?.value
  //   ) {
  //     // presente estero
  //     return true;
  //   }

  //   return false;
  // }, [formContext.values.typeResidence, formContext.values.residence]);

  // const onChangeVisibility = useEventCallback(() => {
  //   onChangeVisibilityWarning();
  // });

  const isEffectiveDateFiled: boolean | undefined | null = useMemo(() => {
    return (
      formContext.values?.effectiveDate &&
      formContext.values?.effectiveDate?.toString() !== 'Invalid DateTime'
    );
  }, [formContext.values?.effectiveDate]);

  return (
    <Fragment>
      <Grid item container spacing={2}>
        {/* <Grid item xs={12}>
          <SearchMessages
            type={MessageType.Warning}
            title="Warning"
            messages={warning.warning as Array<Message>}
            visibility={warning.open as boolean}
            onChangeVisibility={onChangeVisibility}
          />
        </Grid> */}
        <Grid item xs={12}>
          <Grid item xs={12} md={4}>
            <DatePicker
              label={ForPracticeTemporary ? 'Decorrenza' : 'Decorrenza *'}
              aria-label="Decorrenza"
              value={formContext.values?.effectiveDate || null}
              onChange={(date) => {
                formContext.setFieldValue('effectiveDate', date || null);
              }}
              disabled={formContext.values.isFromData || disabled}
              renderInput={(params) => (
                <PmiTextField
                  id="effectiveDate"
                  {...params}
                  fullWidth
                  error={
                    formContext.touched.effectiveDate && Boolean(formContext.errors.effectiveDate)
                  }
                  helperText={formContext.errors.effectiveDate}
                />
              )}
            />
          </Grid>
        </Grid>
        {typeRegister === TypeRegister.Emigration &&
        fromPerson === TypeInitiative.idUfficio &&
        formContext.values.citizenshipNumber === Number.parseInt(CODE_STATE_ITALIAN, 10) ? (
          <Grid item container spacing={2}>
            <Grid item xs={12} md={4}>
              <PmiTextField
                id="subscription-number"
                label="Nr. Iscrizione AIRE Consolato"
                aria-label="Nr. Iscrizione AIRE Consolato"
                fullWidth
                onChange={(event) => {
                  formContext.setFieldValue('subscriptionNumber', event.target.value);
                }}
                value={formContext.values?.subscriptionNumber || ''}
                error={
                  formContext.touched?.subscriptionNumber &&
                  Boolean(formContext.errors?.subscriptionNumber)
                }
                helperText={formContext.errors?.subscriptionNumber}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DatePicker
                label="Data Iscrizione AIRE Consolato"
                aria-label="Data Iscrizione AIRE Consolato"
                value={formContext.values?.dateSubscriptionNumber || null}
                onChange={(date) => formContext.setFieldValue('dateSubscriptionNumber', date)}
                disabled={disabled}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="dateSubscription"
                    fullWidth
                    error={
                      formContext.touched?.dateSubscriptionNumber &&
                      Boolean(formContext.errors?.dateSubscriptionNumber)
                    }
                    helperText={formContext.errors?.dateSubscriptionNumber}
                  />
                )}
              />
            </Grid>
          </Grid>
        ) : undefined}

        {ForPracticeTemporary ? undefined : (
          <>
            <Grid item xs={12} md={4}>
              <StepButton
                variant="outlined"
                color="cdmBrandThird"
                fullWidth
                disabled={
                  disabled || disabledButtons
                  // formContext.values.typeResidence === ResidenceID.family ||
                  // formContext.values.typeResidence === ResidenceID.domesticPartnership
                  // formContext.values.typeResidence === ResidenceID.new ||
                  // controlButtonNew
                }
                active={
                  formContext.values.typeResidence === ResidenceID.new ||
                  formContext.values.typeResidence === ResidenceID.allFamily
                }
                onClick={() => {
                  if (
                    formContext.values.typeResidence === ResidenceID.new ||
                    formContext.values.typeResidence === ResidenceID.allFamily
                  ) {
                    onEdit();

                    return;
                  }

                  onChangeTypeResidence(ResidenceID.new);
                  // apertura modale
                  setModalNewResidence({ open: true, isEdit: false });
                }}
              >
                <Box
                  sx={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <StepTypography
                    active={
                      formContext.values.typeResidence === ResidenceID.new ||
                      formContext.values.typeResidence === ResidenceID.allFamily
                    }
                    disabled={
                      disabled || disabledButtons
                      // formContext.values.typeResidence === ResidenceID.family ||
                      // formContext.values.typeResidence === ResidenceID.domesticPartnership
                      // formContext.values.typeResidence === ResidenceID.new ||
                      // controlButtonNew
                    }
                  >
                    Nuova residenza
                  </StepTypography>
                </Box>
              </StepButton>
            </Grid>

            <Grid item xs={12} md={4}>
              <StepButton
                variant="outlined"
                color="cdmBrandThird"
                fullWidth
                disabled={
                  disabled || disabledButtons
                  // formContext.values.typeResidence === ResidenceID.new ||
                  // formContext.values.typeResidence === ResidenceID.domesticPartnership ||
                  // formContext.values.typeResidence === ResidenceID.allFamily
                  // formContext.values.typeResidence === ResidenceID.family
                }
                active={formContext.values.typeResidence === ResidenceID.family}
                onClick={() => {
                  if (formContext.values.typeResidence === ResidenceID.family) {
                    onEdit();

                    return;
                  }

                  onChangeTypeResidence(ResidenceID.family);
                  // apertura modale per ricerca famiglia
                  setModalFamily({ open: true, isEdit: false });
                }}
              >
                <Box
                  sx={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <StepTypography
                    active={formContext.values.typeResidence === ResidenceID.family}
                    disabled={
                      disabled || disabledButtons
                      // formContext.values.typeResidence === ResidenceID.new ||
                      // formContext.values.typeResidence === ResidenceID.domesticPartnership ||
                      // formContext.values.typeResidence === ResidenceID.allFamily
                      // formContext.values.typeResidence === ResidenceID.family
                    }
                  >
                    {typeRegister === TypeRegister.Emigration
                      ? 'Residenza in famiglia AIRE'
                      : 'Residenza in famiglia già esistente'}
                  </StepTypography>
                </Box>
              </StepButton>
            </Grid>
          </>
        )}

        {typeRegister === TypeRegister.Emigration || ForPracticeTemporary ? undefined : (
          <Grid item xs={12} md={4}>
            <StepButton
              variant="outlined"
              color="cdmBrandThird"
              fullWidth
              disabled={
                disabled ||
                disabledButtons ||
                // formContext.values.typeResidence === ResidenceID.family ||
                // formContext.values.typeResidence === ResidenceID.new ||
                // formContext.values.typeResidence === ResidenceID.allFamily ||
                // formContext.values.typeResidence === ResidenceID.domesticPartnership ||
                (typePractice === TypeRegister.Residence && intestatarioIsAnpr)
              }
              active={formContext.values.typeResidence === ResidenceID.domesticPartnership}
              onClick={() => {
                if (formContext.values.typeResidence === ResidenceID.domesticPartnership) {
                  onEdit();

                  return;
                }

                onChangeTypeResidence(ResidenceID.domesticPartnership);
                // apertura modale per ricerca convivenza
                setModalDomesticPartnership({ open: true, isEdit: false });
              }}
            >
              <Box
                sx={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
              >
                <StepTypography
                  active={formContext.values.typeResidence === ResidenceID.domesticPartnership}
                  disabled={
                    disabled ||
                    disabledButtons ||
                    // formContext.values.typeResidence === ResidenceID.family ||
                    // formContext.values.typeResidence === ResidenceID.new ||
                    // formContext.values.typeResidence === ResidenceID.allFamily ||
                    // formContext.values.typeResidence === ResidenceID.domesticPartnership ||
                    (typePractice === TypeRegister.Residence && intestatarioIsAnpr)
                  }
                >
                  Residenza in convivenza
                </StepTypography>
              </Box>
            </StepButton>
          </Grid>
        )}

        <Grid item xs={12}>
          {ForPracticeTemporary && isEffectiveDateFiled ? (
            <PracticeTemporaryActualResidence ForPracticeTemporary={ForPracticeTemporary} />
          ) : undefined}
          {!ForPracticeTemporary ? (
            <AccordionActualResidence
              ForPracticeTemporary={ForPracticeTemporary}
              disabled
              onEdit={onEdit}
              disabledAll={disabled}
              yearId={yearId}
              progressive={progressive}
              typeRegister={typeRegister}
            />
          ) : undefined}
        </Grid>
      </Grid>

      <ModalNewResidence
        open={modalNewResidence.open}
        onClose={() => {
          setModalNewResidence({ open: false, isEdit: modalNewResidence.isEdit });

          if (!modalNewResidence.isEdit) {
            onChangeTypeResidence('');
          }
        }}
        onConfirm={onConfirmNewResidence}
        codeEnte={codeEnte}
        typeResidence={formContext.values.typeResidence}
        typeRegister={typeRegister}
        intestatarioIsAnpr={intestatarioIsAnpr}
        yearId={yearId}
        progressive={progressive}
        typePractice={typePractice}
        initialValues={{
          ...(formContext.values.residence || {}),
          italian: {
            ...(formContext.values.residence?.italian || {}),
            addressAuto: formContext.values.residence?.italian?.addressAuto?.description
              ? formContext.values.residence?.italian?.addressAuto
              : formContext.values.residence?.italian?.address,
          },
        }}
      />
      <ModalFamily
        open={modalFamily.open}
        onClose={() => {
          setModalFamily({ open: false, isEdit: modalFamily.isEdit });

          if (!modalFamily.isEdit) {
            onChangeTypeResidence('');
          }
        }}
        onConfirm={(
          table?: TableNewFamilySubjectsVM,
          residence?: FormActualResidenceVM,
          tableFamiliar?: TableFamiliarVM
        ) => {
          setModalFamily({ open: false, isEdit: modalFamily.isEdit });

          formContext.setValues({
            ...formContext.values,
            tableFamiliar,
            tableNewFamilySubjects: table || undefined,
            residence: residence || formContext.values.residence || undefined,
          });
        }}
        idFamilyAnpr={idFamilyAnpr}
        codeEnte={codeEnte}
        iniziativa={iniziativa}
        yearId={yearId}
        typeRegister={typeRegister}
        progressive={progressive}
        typePractice={typePractice}
        initialValuesResidence={formContext.values.residence}
        initialValuesTableNewFamily={formContext.values.tableNewFamilySubjects}
      />
      <ModalDomesticPartnership
        open={modalDomesticPartnership.open}
        onClose={() => {
          setModalDomesticPartnership({ open: false, isEdit: modalDomesticPartnership.isEdit });

          if (!modalDomesticPartnership.isEdit) {
            onChangeTypeResidence('');
          }
        }}
        onConfirm={(table?: TableDomesticPartnershipVM, residence?: FormActualResidenceVM) => {
          formContext.setValues({
            ...formContext.values,
            tableDomesticPartnership: table || undefined,
            residence: residence || formContext.values.residence || undefined,
          });
          setModalDomesticPartnership({ open: false, isEdit: modalDomesticPartnership.isEdit });
        }}
        idFamilyAnpr={idFamilyAnpr}
      />
    </Fragment>
  );
};

FormComponent.displayName = 'Accordion Residence - form';

const Form = memo(FormComponent);

export default Form;
